module.exports = __webpack_public_path__ + "static/media/Ad-Server-Dashboard-1.4649d33d.jpg";